import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
import {
  getToken,
  setToken,
  removeToken,
  getStoreId,
  setStoreId,
  removeStoreId,
  setUserInfo,
  getUserInfo,
  removeUserInfo
} from "@/utils/cookies";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
      meta: { title: "莽盒电竞", hidden: true, notNeedAuth: true }
    },
    {
      path: "/404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
      meta: { title: "莽盒电竞", hidden: true, notNeedAuth: true }
    },
    {
      path: "/",
      component: Layout,
      redirect: "/dashboard",
      children: [
        {
          path: "dashboard",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"),
          name: "Dashboard",
          meta: {
            title: "工作台",
            icon: "dashboard",
            affix: true
          }
        },
		{
          path: "statistics",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/statistics/index.vue"),
          meta: {
            title: "数据统计",
            icon: "icon-statistics"
          }
        },
        {
          path: "order",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/order/index.vue"),
          meta: {
            title: "订单管理",
            icon: "icon-order"
          }
        },
        {
          path: "draw",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/draw/index.vue"),
          meta: {
            title: "抽奖管理",
            icon: "icon-combo"
          }
        },
        {
          path: "draw/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/draw/addDraw.vue"),
          meta: {
            title: "添加抽奖",
            hidden: true
          }
        },
        {
          path: "prize",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/draw/prize.vue"),
          meta: {
            title: "奖品管理",
            icon: "icon-combo"
          }
        },
        {
          path: "prize/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/draw/addPrize.vue"),
          meta: {
            title: "添加奖品",
            hidden: true
          }
        },
        {
          path: "dish",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/goods/index.vue"),
          meta: {
            title: "商品管理",
            icon: "icon-dish"
          }
        },
        {
          path: "dish/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/goods/addGoodstype.vue"),
          meta: {
            title: "添加商品",
            hidden: true
          }
        },
        
        {
          path: "category",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/category/index.vue"),
          meta: {
            title: "分类管理",
            icon: "icon-category custom-iconfont"
          }
        },
        {
          path: "employee",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/user/index.vue"),
          meta: {
            title: "用户管理",
            icon: "icon-employee"
          }
        },
        
        {
          path: "employee/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/user/addUser.vue"),
          meta: {
            title: "添加用户",
            hidden: true
          }
        },
        
        {
          path: "dashou",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/goons/index.vue"),
          meta: {
            title: "员工管理",
            icon: "icon-goonsicon custom-iconfont"
          }
        },
        {
          path: "apply",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/goons/apply.vue"),
          meta: {
            title: "员工入驻管理",
            icon: "icon-goonsicon custom-iconfont"
          }
        },
        
        {
          path: "dashou/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/goons/addGoons.vue"),
          meta: {
            title: "添加员工",
            hidden: true
          }
        },

        {
          path: "notice",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/notice/index.vue"),
          meta: {
            title: "公告管理",
            icon: "icon-notice custom-iconfont"
          }
        },
        {
          path: "notice/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/notice/addNotice.vue"),
          meta: {
            title: "添加公告",
            hidden: true
          }
        },
        {
          path: "notice/detail",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/notice/detail.vue"),
          meta: {
            title: "公告详情",
            hidden: true
          }
        },

        {
          path: "goons-announcement",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/goonsAnnouncement/index.vue"),
          meta: {
            title: "打手公告管理",
            icon: "icon-goonsicon custom-iconfont"
          }
        },
        {
          path: "goons-announcement/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/goonsAnnouncement/addGoonsAnnouncement.vue"),
          meta: {
            title: "添加打手公告",
            hidden: true
          }
        },

        {
          path: "withdraw",
          component: () =>
            import(/* webpackChunkName: "withdraw" */ "@/views/withdraw/index.vue"),
          meta: {
            title: "提现管理",
            icon: "icon-goonsicon custom-iconfont"
          }
        },

        {
          path: "pc-price-markup",
          component: () =>
            import(/* webpackChunkName: "pcPriceMarkup" */ "@/views/pcPriceMarkup/index.vue"),
          meta: {
            title: "PC端价格配置",
            icon: "icon-statistics"
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/404",
      meta: { hidden: true }
    }
  ]
});

export default router;
